import { iChromiaState, tDiscountPercent } from "../../interfaces"
import { discountPercents } from "../../settings";
import { eChromiaActionTypes, tChromiaAction } from "./chromiaTypes"

const initialState: iChromiaState = {
	session: null,
	chrClientAddr: null,
	gtxClient: null,
	// deposits: discountPercents.reduce((accum, val) => ({...accum, [val as tDiscountPercent]: []}), {}) as {[key in tDiscountPercent]: []},
	deposits: Object.fromEntries(discountPercents.map(percent => [percent, []])) as {[key in tDiscountPercent]: []},
	launches: [],
	periods: [],
	isChrRegistered: true,
	items: Object.fromEntries(discountPercents.map(percent => [percent, null])) as {[key in tDiscountPercent]: null},
	endTimes: Object.fromEntries(discountPercents.map(percent => [percent, 0])) as {[key in tDiscountPercent]: number},
}

export const chromiaReducer = (state = initialState, action: tChromiaAction): iChromiaState => {
	switch(action.type){

		case eChromiaActionTypes.CLEAR_STATE:
			return initialState
		;

		case eChromiaActionTypes.SET_SESSION:
			return {...state, session: action.payload}
		;

		case eChromiaActionTypes.SET_CHR_CLIENT_ADDR:
			return {...state, chrClientAddr: action.payload}
		;

		case eChromiaActionTypes.SET_GTX_CLIENT:
			return {...state, gtxClient: action.payload}
		;

		case eChromiaActionTypes.SET_DEPOSITS:
			return {
				...state,
				deposits: Object.assign(
					{},
					state.deposits,
					{[action.payload.percent]: action.payload.deposits}
				)
			}
		;

		case eChromiaActionTypes.SET_LAUNCHES:
			return {...state, launches: action.payload}
		;

		case eChromiaActionTypes.SET_PERIODS:
			return {...state, periods: action.payload}
		;
		
		case eChromiaActionTypes.SET_IS_CHR_REGISTERED:
			return {...state, isChrRegistered: action.payload}
		;

		case eChromiaActionTypes.SET_ITEM:
			return {
				...state,
				items: Object.assign(
					{},
					state.items,
					{[action.payload.percent]: action.payload.item}
				)
			}
		;

		case eChromiaActionTypes.SET_END_TIME:
			return {
				...state,
				endTimes: Object.assign(
					{},
					state.endTimes,
					{[action.payload.percent]: action.payload.endTime}
				)
			}
		;

		default: return state;
	}
}